var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[_c('span',{staticClass:"chip chip-custom",class:{[_vm.chipClasses.join(' ')]: true},style:({ backgroundColor: _vm.chipColor, borderColor: _vm.borderColor}),on:{"click":_vm.onClickChip}},[_vm._v(_vm._s(_vm.chipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }